import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogContent,
  DialogActions
} from '@material-ui/core';
import {
  buySubscriptionPlanAddonsApi
} from 'api';


const extraPromoOptions = [
  { maxPromoSkus: 10, maxActivePromos: 1, price: 1 },
  { maxPromoSkus: 30, maxActivePromos: 3, price: 2 },
  { maxPromoSkus: 50, maxActivePromos: 5, price: 3 }
];

export default function BuyExtraPromosModal({ showPurchaseModal, setShowPurchaseModal }) {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(0);

  const handleClickBuy = async () => {
    const option = extraPromoOptions[selectedOption];
    await buySubscriptionPlanAddonsApi({ ...option, dispatch });
    setShowPurchaseModal(false);
  };

  return (
    <Dialog
      open={showPurchaseModal}
      onClose={() =>  setShowPurchaseModal(false)}
    >
      <DialogContent>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Select an option:</FormLabel>
          <RadioGroup
            value={selectedOption}
            name="radio-buttons-group"
            onChange={(_e, option) => setSelectedOption(Number(option))}
          >
            {extraPromoOptions.map((option, idx) => {
              const label = `${option.maxPromoSkus} SKUS and ${option.maxActivePromos} concurrent promos - $${option.price}`;
              return (
                <FormControlLabel key={`option-${idx}`} value={idx} control={<Radio />} label={label} />
              );
            })}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="contained" onClick={() =>  setShowPurchaseModal(false)}>Cancel</Button>
        <Button color="primary" variant="contained" onClick={handleClickBuy}>Buy</Button>
      </DialogActions>
    </Dialog>
  );
}
